module.exports = __webpack_public_path__ + "static/media/aspas.37c8f96b.jpg";